module.exports = __webpack_public_path__ + "img/483a094.jpg";